/**
 * Created by Pankaj singh on 2019-09-09.
 */
export class RomanEmpireEvents {

    public static readonly SHOW_WIN_BET_LINE_WIN_AMOUNT: string = "showWinBetLineWinAmount";
    public static readonly ON_MULTIPLIER_COUNT_UP: string = "onMultiplierCountUp";
    public static readonly GENIE_TIMES_BET_COIN_WIN_COUNT_UP_TRIGGERED: string = "genieTimesBetCoinWinCountUpTriggered";
    public static readonly ON_LINE_SHINE_MASK_CREATED: string = "onLineShineMaskCreated";
    public static readonly BET_LINES_DRAW_COMPLETED: string = "betLinesDrawCompleted";
    public static readonly HIDE_WIN_LINE_AMOUNT: string = "hideWinLineAmount";
    public static readonly ON_GAME_START: string = "onGameStart";
    public static readonly PLAY_SCATTER_ANTICIPATION_ANIM: string = "playScatterAnticipation";
    public static readonly HIDE_SCATTER_ANTICIPATION_ANIM: string = "hideScatterAnticipation";
    public static readonly TRANSFORM_TO_WILD: string = "transformToWild";
    public static readonly ON_NO_WIN_PRESENTATION: string = "onNoWinPresentation";
    public static readonly ON_SCATTER_REVEAL: string = "onScatterReveal";
    public static readonly ON_REEL_STOP_SPIN: string = "onReelStopSpin";
    public static readonly ON_GOLDEN_GENIE_HANDOVER_START: string = "onGoldenGenieHandoverStart";
    public static readonly ON_GOLDEN_GENIE_HANDOVER_END: string = "onGoldenGenieHandoverEnd";
    public static readonly ON_FINAL_MULTIPLIER_MOVE_START: string = "onGoldenGenieFinalMultiplierMoveStart";
    public static readonly ON_FINAL_MULTIPLIER_MOVE_END: string = "onGoldenGenieFinalMultiplierMoveEnd";
    public static readonly ON_REEL_BOUNCE: string = "onReelBounce";
    public static readonly ON_BIG_WIN_ANIM_START: string = "onBigWinAnimStart";
}